module.exports = __webpack_public_path__ + "media/images/icons/v2/chevron-left-bbf951d6f9cf5c9341abd4e81c314095.svg";